import styled, { css } from 'styled-components';
import breakpoint, { getZindexByType } from '~/utils/style-utils.ts';

export const GameInfoContainer = styled.div`
	--regHeaderTop: calc(var(--regulationHeight) + var(--headerHeight) + var(--subHeaderHeight));
	--headerTop: calc(var(--headerHeight) + var(--subHeaderHeight));

	display: grid;
	align-content: start;
	grid-template-columns: 1fr;
	grid-gap: 12px;
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 100%;
	background: rgba(var(--gameInfoBg), 1);
	box-shadow: -2px 0px 3px rgba(0, 0, 0, 0.18);
	transition: all 0.3s ease;
	z-index: ${getZindexByType('game-info')};
	overflow-y: auto;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;

	${breakpoint.lg`
		width: 375px;
    right: -375px;
  `};

	${props =>
		props.active &&
		css`
			top: 0;

			${breakpoint.lg`
				top: var(--headerTop);
				right: 0;
			`};
		`};

	${props =>
		props.active &&
		props.regulated &&
		css`
			top: var(--regulationHeight);
			height: calc(100vh - var(--regulationHeight));

			${breakpoint.lg`
				top: var(--regHeaderTop);
				right: 0;
				height: calc(100vh - var(--regHeaderTop));
			`};
		`};
	p,
	h2,
	button {
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const ImageContainer = styled.div`
	height: 270px;
`;

export const ExitButton = styled.button`
	width: 32px;
	height: 32px;
	background-color: var(--game-info-exit-bg-color);
	border-radius: 50%;
	padding: 3px 4px;
	position: absolute;
	z-index: 1;
	left: 12px;
	top: 12px;
	outline: none;
	.icon--sprite {
		fill: var(--game-info-exit-icon-color);
	}
`;

export const TitleContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr auto;
	grid-gap: 5px;
	padding: 7px 12px;
`;

export const GameName = styled.h2`
	grid-column: 1/2;
	grid-row: 1/2;
	font: var(--h2);
	color: rgba(var(--gameInfoTitleName), 1);
	overflow: hidden;
`;

export const ProviderName = styled.p`
	grid-column: 1/2;
	grid-row: 2/3;
	font: var(--caption);
	color: rgba(var(--gameInfoTitleProvider), 1);
	overflow: hidden;
`;

export const LoveButton = styled.button`
	grid-column: 2/3;
	grid-row: 1/3;
	background: rgba(var(--gameInfoLoveButton), 1);
	width: 52px;
	height: 52px;
	border-radius: 50%;
	outline: none;

	.icon--sprite {
		margin: auto;
		fill: rgba(var(--gameInfoLoveIcon), 1);
	}
`;

export const DescriptionContainer = styled.div`
	padding: 0 12px;
	min-width: 0;

	p {
		color: rgba(var(--gameInfoDescText), 1);
		font: var(--label-regular);
	}
`;

export const InfoButton = styled.button`
	height: 52px;
	border: 1px solid rgba(var(--gameInfoButtonBorder), 1);
	border-radius: 26px;
	outline: none;
	font: var(--gameInfoButtonFont);
	color: rgba(var(--gameInfoButtonText), 1);
	margin: 0 12px;
	min-width: 0;
`;

export const DetailsContainer = styled.div`
	padding: 0 12px 200px;
	min-width: 0;
`;

export const DetailsItem = styled.div`
	height: 80px;
	background: rgba(var(--gameInfoDetailBg), 1);
	border-radius: 3px;
	width: 100%;
	display: grid;
	justify-content: center;
	align-content: center;
	text-align: center;
`;

export const DetailAmount = styled.h2`
	font: var(--h2);
	color: rgba(var(--gameInfoDetailAmount), 1);
	margin: 0;
`;

export const DetailTitle = styled.p`
	font: var(--caption);
	color: rgba(var(--gameInfoDetailTitle), 1);
	padding: 0 0 5px 0;
`;

export const PlayRealContainer = styled.div`
	position: fixed;
	width: inherit;
	height: 75px;
	transition: all 0.2s ease;
	bottom: -75px;
	padding: 12px;
	bottom: 0;
`;

export const PlayRealButton = styled.button`
	background: rgba(var(--gameInfoPlayRealButtonBg), 1);
	border-radius: var(--button-border-radius, 3px);
	font: var(--gameInfoButtonFont);
	color: rgba(var(--gameInfoPlayRealButtonText), 1);
	outline: none;
	width: 100%;
	height: 100%;
`;

export const VisibilityWrapper = styled.div`
	display: inline-block;
	visibility: ${props => (props.visible ? 'visible' : 'hidden')};
	width: ${props => (props.visible ? '100%' : '0px')};
	height: ${props => (props.visible ? '100%' : '0px')};
`;
